import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    wrapper: 'pt-7'
  }
} satisfies RecursivePartial<DialogConfig['forgotPassword']>
